// import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Login from "../components/Login";
import Register from "../components/Register";

function LandingPage(props) {
  const [isLogin, setIsLogin] = useState(true);

  return (
    <div className="App">
      {isLogin ? (
        <Login setIsLogin={setIsLogin} />
      ) : (
        <Register setIsLogin={setIsLogin} />
      )}
    </div>
  );
}

export default LandingPage;
